
import React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import type { ButtonProps } from '@mui/material/Button';

const ShareYourLightButton = styled(Button)<ButtonProps>(({ theme, variant }) => {
  const baseStyles = {
    height: '42px', // Set button height
    minHeight: '42px',
  };

  if (variant === 'outlined') {
    return {
      ...baseStyles,
      border: '1px solid #F0CD8B',
      color: '#F0CD8B',
      transition: 'background 0.3s, box-shadow 0.3s, color 0.3s',
      '&:hover': {
        border: '1px solid #D37C1F',
        background: 'linear-gradient(90deg, #FFE6AE 0%, #F4910D 100%)',
        boxShadow: '0 0 50px 0 rgba(255, 238, 142, 0.75)',
        color: '#000',
      },
      '&.Mui-disabled': {
        opacity: 0.5,
        pointerEvents: 'none',
      },
    };
  }
  if (variant === 'contained') {
    return {
      ...baseStyles,
      border: '1.5px solid #D37C1F',
      color: '#000',
      backgroundImage: 'linear-gradient(90deg, #FFE6AE 0%, #F4910D 50%, #FFE6AE 100%)',
      backgroundSize: '200% 100%',
      backgroundPosition: '0% 0%',
      boxShadow: 'none',
      transition: 'background-position 300ms ease, box-shadow 0.3s, color 0.3s',
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundPosition: '100% 0%',
        backgroundColor: 'transparent',
        boxShadow: '0 0 50px 0 rgba(255, 238, 142, 0.75)',
      },
      '&.Mui-disabled': {
        opacity: 0.5,
        pointerEvents: 'none',
      },
    };
  }
  return baseStyles;
});


interface SYLButtonProps extends ButtonProps {
  children: React.ReactNode;
}

export default function SYLButton({ children, ...props }: SYLButtonProps) {
  return (
    <ShareYourLightButton {...props}>
      {children}
    </ShareYourLightButton>
  );
}
